import React, { useState } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';

import {
  Field,
  Form,
  reduxForm,
} from 'redux-form';

import TranslatedCopy from '../../../intl/translated-copy';
import { USER_PROFILE_PASSWORD_PIN_RESET_FORM_ID } from '../../../constants/form-ids';
import regexMap from '../../../constants/regex-map';
import userProfileAccountValidation from '../../../validation/user-profile/user-profile-account/user-profile-account-validation';

import FormInputText from '../../global/form-input-text';
import Btn from '../../global/button';
import Pictogram from '../../global/pictogram';

import UserProfileRecoverPasswordSuccess from './user-profile-recover-password-success';
import LoadingScreen from '../../global/loading-screen';
import { otpRecoverPasswordTypeErrors, recoverPasswordMicroTypeErrors } from '../../../constants/user-profile-recover-password-codes';
import FormOtpLoginError from '../form-otp-login-error';
import { submitAccountPasswordPinReset } from '../../../../redux/actions';
import UserProfileErrorDisconnection from '../user-profile-error-disconnection';

const mapStateToProps = state => {
  return ({
    dispatch: state.dispatch,
    passwordPinResetForm: state.form[USER_PROFILE_PASSWORD_PIN_RESET_FORM_ID],
    profileRecoverPasswordPin: state.Manage.profileRecoverPasswordPin,
  });
};

let UserProfileRecoverPasswordForm = (props) => {
  const {
    handleBackButtonClick,
    invalid,
    onCloseModal,
    onSubmitForm,
    profileRecoverPasswordPin: {
      recoverPasswordPinError = null,
      recoverPasswordLoading,
      recoverPasswordPinSent = null,
    },
  } = props;

  const [data, setData] = useState({
    confirmPassword: '',
    newPassword: '',
  });

  const isPasswordLengthMinEight = data.newPassword.length >= 8;
  const isAtLeastOneUpperCase = regexMap.AT_LEAST_ONE_UPPERCASE.test(data.newPassword);
  const isCombinationNumbersLetters = regexMap.IS_COMBINATION_LETTERS_NUMBERS.test(data.newPassword);
  const noSpecialCharcaters = data.newPassword.length > 0 && regexMap.ALPHANUMERIC_BOTH.test(data.newPassword);
  const isMatch = (isPasswordLengthMinEight && isAtLeastOneUpperCase && isCombinationNumbersLetters && noSpecialCharcaters);

  const pinNumberRules = [
    { copyId: 'PRO_HOME_NEW_PASSWORD_EIGHT', matchRule: isPasswordLengthMinEight },
    { copyId: 'PRO_HOME_NEW_PASSWORD_COMBINATION', matchRule: isCombinationNumbersLetters },
    { copyId: 'PRO_HOME_NEW_PASSWORD_CAPITAL', matchRule: isAtLeastOneUpperCase },
    { copyId: 'PRO_HOME_NEW_PASSWORD_SPECIAL', matchRule: noSpecialCharcaters },
  ];

  const submitPassword = () => {
    const { confirmPassword } = data;

    onSubmitForm(confirmPassword);
  };

  const handleChange = (event, name) => {
    const value = event.target.value;

    setData({ ...data, [name]: value });
  };

  const handleOnRetryOtp = () => {
    const {
      dispatch,
    } = props;

    const otpError = Boolean(otpRecoverPasswordTypeErrors.includes(code));
    const microError = Boolean(recoverPasswordMicroTypeErrors.includes(code));

    dispatch(submitAccountPasswordPinReset());
    handleBackButtonClick({ microError, otpError });
  };

  const {
    maskedEmail = null,
  } = recoverPasswordPinSent || {};

  const {
    code = null,
  } = recoverPasswordPinError || {};

  const showLoading = Boolean(recoverPasswordLoading);
  const otpError = Boolean(otpRecoverPasswordTypeErrors.includes(code));
  const microError = Boolean(recoverPasswordMicroTypeErrors.includes(code));
  const showErrorModal = otpError || microError;
  const showSuccessModal = Boolean(maskedEmail && !showErrorModal);

  const FormClasses = cx('UserProfileSettingsPasswordReset', {
    'UserProfileSettingsPasswordReset--Loading': showLoading,
  });

  return (
    showSuccessModal ?
      <UserProfileRecoverPasswordSuccess onBackButtonClick={ handleOnRetryOtp } />
      :
      !showErrorModal ?
        <div className={ FormClasses }>
          { showLoading &&
            <LoadingScreen
              isDataLoading={ true }
              seatmap={ true }
              type='airplaneWindow'
            />
          }
          <Form
            className='UserProfileSettingsPasswordReset-form'
            onSubmit={ (e) => { e.preventDefault(); } }>
            <div className='UserProfileSettingsPasswordReset-form-section'>
              <button
                className='UserProfileRecoverPasswordOrPin-back'
                onClick={ handleOnRetryOtp }
                type='button'>
                <span className='Icon Icon--calendarArrowLeft' />
                <TranslatedCopy
                  className='UserProfileRecoverPasswordOrPin-back-Text'
                  copyID='PRO_HOME_FORGOT_LOGIN'
                />
              </button>
              <TranslatedCopy
                className='UserProfileSettingsPasswordReset-title Form-title'
                copyID='PRO_HOME_NEW_PASSWORD_TITLE'
                tagName='h4'
              />
              <ul className='UserProfileSettingsPasswordReset-rules-list'>
                { pinNumberRules.map( ({ copyId, matchRule }, index) => {
                  const pictogramId = matchRule ? 'circleOnNewFill' : 'circleOnDisabled';

                  return (
                    <li
                      className='UserProfileSettingsPasswordReset-item'
                      key={ index }>
                      { isMatch ?
                        <span className='allMatchIcon Icon Icon--check' />
                        :
                        <Pictogram
                          className='UserProfileSettingsPasswordReset-bullet-icon'
                          id={ pictogramId }
                        />
                      }
                      <TranslatedCopy
                        className='UserProfileSettingsPasswordReset-item-text'
                        copyID={ copyId }
                      />
                    </li>
                  );
                })
                }
              </ul>
              <Field
                className='UserProfileSettingsPasswordReset-newPassword FormInput-wrapper FormInput-new-design tooltip-z-index'
                component={ FormInputText }
                labelClassModifier='passwd'
                labelCopyID='PRO_HOME_NEW_PASSWORD'
                name='newPassword'
                onChange={ (e) => handleChange(e, 'newPassword') }
                showIcon={ true }
                type={ 'password' }
              />
              <Field
                className='UserProfileSettingsPasswordReset-confirmPassword FormInput-wrapper FormInput-new-design tooltip-z-index'
                component={ FormInputText }
                labelClassModifier='passwd'
                labelCopyID='PRO_HOME_NEW_PASSWORD_CONFIRM'
                name='confirmPassword'
                onChange={ (e) => handleChange(e, 'confirmPassword') }
                showIcon={ true }
                type={ 'password' }
              />
            </div>
            <div className='UserProfileSettingsPasswordReset-submit-section Form-submit'>
              <Btn
                btnType='submit'
                className='UserProfileSettingsPasswordReset-submit'
                copyID='PRO_HOME_NEW_PASSWORD_BUTTON'
                disabled={ (!data.newPassword && !data.confirmPassword) || invalid }
                filledRed={ true }
                onBtnClick={ () => submitPassword() }
              />
            </div>
            <TranslatedCopy
              className='UserProfileSettingsPasswordReset-captcha'
              copyID='PRO_HOME_FORGOT_CAPTCHA'
              tagName='p'
            />
          </Form>
        </div>
        :
        <>
          { otpError &&
            <FormOtpLoginError handleButtonClick={ handleOnRetryOtp } />
          }
          { microError &&
            <UserProfileErrorDisconnection
              onBackButtonClick={ handleOnRetryOtp }
              onCloseModal={ onCloseModal }
            />
          }
        </>
  );
};

UserProfileRecoverPasswordForm = reduxForm({
  destroyOnUnmount: true,
  form: USER_PROFILE_PASSWORD_PIN_RESET_FORM_ID,
  validate: userProfileAccountValidation,
})(UserProfileRecoverPasswordForm);

UserProfileRecoverPasswordForm = connect(mapStateToProps)(UserProfileRecoverPasswordForm);

export default UserProfileRecoverPasswordForm;
